import React, { useEffect, useState } from "react";
import { Card, Col, Divider, Row } from "antd";
import useApi from "../../hooks/useApi";
import { isEmpty } from "../../generalFunctions";
import { BLANK_VALUE } from "../../constants";

const Manyavar = () => {
  const [response, request] = useApi("/website/manyavar");
  const [manyavars, setManyavar] = useState([]);

  useEffect(() => {
    request();
  }, []); //eslint-disable-line

  useEffect(() => {
    if (!isEmpty(response.data) && !response.error && !response.isLoading) {
      setManyavar(response.data);
    }
  }, [response]);

  return (
    <>
      <Row gutter={[16, 16]}>
        {manyavars.map((manyavar) => (
          <Col xl={6} lg={6} md={6} sm={24} xs={24} key={manyavar.id}>
            <Card
              key={manyavar.id}
              hoverable
              style={{ width: 320, minHeight: 475 }}
              cover={<img alt={manyavar.name} src={manyavar.image} />}
            >
              <h2>{manyavar.name}</h2>
              <h3>{manyavar.post}</h3>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default Manyavar;
